// @flow
import {connect} from 'react-redux';
// import {bindActionCreators} from 'redux';
import Configuration from '../components/Configuration/Configuration';

import type {RootState} from '../../..';
// import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
  }),
  null
)(Configuration);
